var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g({class:_vm.wrapperClass},_vm.$listeners),[(_vm.disabled)?_c('span',[_vm._v(_vm._s(_vm.dayText))]):(!_vm.invalidDay)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.dayClicked(_vm.date)}}},[_vm._v(" "+_vm._s(_vm.dayText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }